// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.codes_LxByJ {
  background-color: var(--color-base025);
  font-family: monospace;
  border: 1px solid var(--color-base200);
  padding: var(--size-padMedium);
  border-radius: var(--size-padMedium);
}

.code_pNM2w {
  width: 50%;
  text-align: center;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/node_modules/@leverege/api-ui-login/lib/twoFactor/flows/OneTimeCodes.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,sBAAsB;EACtB,sCAAsC;EACtC,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".codes {\n  background-color: var(--color-base025);\n  font-family: monospace;\n  border: 1px solid var(--color-base200);\n  padding: var(--size-padMedium);\n  border-radius: var(--size-padMedium);\n}\n\n.code {\n  width: 50%;\n  text-align: center;\n  white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"codes": `codes_LxByJ`,
	"code": `code_pNM2w`
};
export default ___CSS_LOADER_EXPORT___;
